import { bindQueryParams } from "src/helpers/tools";
import { methods, request } from "./base";

const insightsApis = {
  getInsightData: async (queryParams: Record<string, string | number>) => {
    const route = queryParams
      ? bindQueryParams("/gfc/loggers/insights_data", queryParams)
      : "/gfc/loggers/insights_data";
    return await request({
      method: methods.GET,
      route,
      priv: true,
    });
  },
  getLogData: async (queryParams: Record<string, string | number>) => {
    const route = queryParams
      ? bindQueryParams("/gfc/loggers", queryParams)
      : "/gfc/logger";
    return await request({
      method: methods.GET,
      route,
      priv: true,
    });
  },
  getHistory: async (queryParams: Record<string, string | number>) => {
    const route = queryParams
      ? bindQueryParams("/gfc/loggers/history", queryParams)
      : "/gfc/loggers/history";
    return await request({
      method: methods.GET,
      route,
      priv: true,
    });
  },
};

export default insightsApis;
